<ion-content>

  <div class="login-card simple-card ion-margin-top">
    <h2 class="login-label text-header mt-0 mb-20">
      dc3-alpha Registrierung
    </h2>
    <form *ngIf="form" [formGroup]="form">
      <ion-input class="ion-margin-top"
                 label="Alpha Key"
                 label-placement="stacked"
                 fill="outline"
                 formControlName="alphaKey">
      </ion-input>
      <ion-input class="ion-margin-top"
                 label="E-Mail"
                 label-placement="stacked"
                 fill="outline"
                 formControlName="email">
      </ion-input>
      <ion-input class="ion-margin-top"
                 label="Passwort"
                 label-placement="stacked"
                 type="password"
                 fill="outline"
                 formControlName="password">
      </ion-input>
      <ion-button class="ion-margin-top"
                  [disabled]="form.invalid"
                  (click)="register()">
        Registrieren
      </ion-button>

      <p *ngIf="registerError">
        <ion-text color="danger">
          Registrierung war nicht möglich. Wahrscheinlich wird die E-Mail schon verwendet.
        </ion-text>
      </p>
      <p *ngIf="alphaKeyError">
        <ion-text color="danger">
          Registrierung war nicht möglich. Wahrscheinlich stimmt dein Alpha Key nicht.
        </ion-text>
      </p>

    </form>

  </div>
</ion-content>
